import axios from 'axios';

/**
 * Dispara evento para workflow Camunda
 */
export async function handleWorkflow(action, formData, config) {
  try{
    const wfKey = action.replace('wf:', '');
    const payload = {
      messageName: wfKey,
      processVariables: {
        formData: { value: formData }
      },
      resultEnabled: true,
      tenantId: config?.tenantId || 'default'
    };
    let resp = await axios.post(
      `${process.env.REACT_APP_MEVIO_APIENDPOINT}workflows/message`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Basic ${process.env.REACT_APP_CAMUNDA_AUTHKEY}`,
          apikey: `${process.env.REACT_APP_MEVIO_APIKEY}`
        }
      }
    );
    console.log(`✅ Workflow '${wfKey}' disparado.`);
    return resp
  }catch(e){
    throw e
  }
}
